import { Model } from 'es6/components/model'
import Backbone from 'init/backbone'
import { Defaults } from 'es-decorators'
import { entryScriptName } from 'init/entry-script-name'
import {
  CQC_COMMAND_TYPES,
  CQC_COMMANDS_TYPES_TO_EVENTS,
  UPDATE_OKO_SETTLEMENT,
} from 'es6/constants'
import { updateOkoInfo } from '../../../common/helpers/oko-helpers'

/**
 * Модель текущего города
 */
@Defaults({
  customsUnionCountries: ['AM', 'BY', 'KZ', 'KG'],
  additionalOptions: ['user', 'requestParameters', 'needSave'],
  urlRoot: `${entryScriptName}/api/v3/settlement-form`,
  needSave: false,
})
export class SettlementForm extends Model {
  /** @inheritDoc */
  run () {
    this.expand = 'expand=has_active_jp_purchase,jp_request_min_sum'
    this.listenTo(Backbone,
      CQC_COMMANDS_TYPES_TO_EVENTS[CQC_COMMAND_TYPES.settlementUpdate],
      this.update)
    this.listenTo(Backbone,
      UPDATE_OKO_SETTLEMENT,
      updateOkoInfo)
  }

  /**
   * Обновление атрибутов новыми данными
   * @param {Object} data - данные
   */
  update (data) {
    const newSettlement = data.settlement
    if (newSettlement.id !== this.currentSettlementId) {
      if (this.needSave) {
        this.save({ settlement_id: newSettlement.id })
      } else {
        this.currentSettlementId = newSettlement.id
        const shippingTime = newSettlement.shipping_time || []
        this.set({
          settlement_id: newSettlement.id,
          name: newSettlement.name,
          region: newSettlement.region,
          phone: newSettlement.contact_phone,
          min_date: shippingTime[0] || null,
          max_date: shippingTime[1] || null,
        })
        updateOkoInfo(newSettlement)
      }
    }
    this.trigger('sync', this, this.toJSON())
  }

  /**
   * Добавление триггера события обновления минимальной суммы
   */
  attachMinSumTrigger () {
    this.listenTo(this, 'sync', function (model) {
      Backbone.trigger('minSumUpdated', model)
    })
  }

  /**
   * Проверяет страну к которой принадлежит город
   * @returns {boolean} true, если город в России
   */
  isRussia () {
    return this.get('country') === 'RU'
  }

  /**
   * Показывать шильдики товаров партнеров и попап заказа
   * @returns {boolean}
   */
  isRemoteStoreEnabled () {
    return ['RU', 'KZ', 'BY'].includes(this.get('country')) && !this.get('is_small_wholesale')
  }
}
